import React, { useState, useRef, useEffect } from "react";
import { IconButton, Stack, Box, Tooltip, Button, Typography } from "@mui/material";
import { useReactToPrint } from "react-to-print";
//Icons
import LocalPrintshopIcon from "@mui/icons-material/LocalPrintshop";
import ReplyIcon from '@mui/icons-material/Reply';
//Srcs
import "../../../Style/actionstyle.scss";
import PrintInvoice from "./PrintInvoice";
import VoidInvoice from "./VoidInvoice";
import RefundInvoice from "./RefundInvoice";
import { GET_STUDENT_PAYMENT_BY_ID } from "../../../Schema/StudentPayment";
import { useQuery } from "@apollo/client";

export default function StudentPaymentAction({
  setRefetch, 
  editData,
  detailsData,
}) {
  //Modal update
  const [openEdit, setOpenEdit] = useState(false);
  const handleOpenEdit = () => setOpenEdit(true);
  const handleCloseEdit = () => setOpenEdit(false);

  //Modal update
  const [openPrint, setOpenPrint] = useState(false);
  const handleOpenPrint = () => setOpenPrint(true);
  const handleClosePrint = () => setOpenPrint(false);


  //Modal update
  const [openRefundInvoice, setOpenRefundInvoice] = useState(false);
  const handleOpenRefundInvoice = () => setOpenRefundInvoice(true);
  const handleCloseRefundInvoice = () => setOpenRefundInvoice(false);


  return (
    <div
    // style={{
    //   backgroundColor: editData?.void
    //     ? "rgb(240, 236, 236) !important"
    //     : "#fff",
    // }}
    >
      <Stack direction="row" justifyContent="right" spacing={1}>

        {/* <Stack direction="column" justifyContent="center">
          <Tooltip title="void invoice" placement="top">
            {editData?.void ? (
              <Button di className="btn-void-disabled">
                Void
              </Button>
            ) : (
              <Button onClick={handleOpenEdit} className="btn-void">
                Void
              </Button>
            )}
          </Tooltip>
        </Stack> */}

        {/* <Tooltip title="print invoice" placement="top">
          <IconButton onClick={handleOpenPrint}>
            <Box className="save-container">
              <LocalPrintshopIcon className="save-icon" />
            </Box>
          </IconButton>
        </Tooltip> */}

        <Tooltip title="refund invoice" placement="top"> 
          <IconButton 
            onClick={handleOpenRefundInvoice}
            disabled={editData?.void}
          > 
            <Box className="save-container">
              <ReplyIcon className="refund-icon" />
            </Box>
            <Typography>
              Refund
            </Typography>
          </IconButton>
        </Tooltip>

      </Stack>

      {/* <PrintInvoice
        open={openPrint}
        editData={editData}
        handleClose={handleClosePrint}
        // studentId={studentId}
        detailsData={detailsData}
      /> */}

      {/* <VoidInvoice
        open={openEdit}
        handleClose={handleCloseEdit}
        editData={editData}
        setRefetch={setRefetch}
      /> */}

      <RefundInvoice
        open={openRefundInvoice}
        handleClose={handleCloseRefundInvoice}
        editData={editData}
        studentId={detailsData?._id}
        setRefetch={setRefetch} 
      />


    </div>
  );
}
